import { createSelector } from 'reselect';
/**
 * The `all` selector returns an array containing every item for a given model.
 * Depends on the [allIds](#makeallidsreducer) and [byId](#makebyidreducer)
 * reducers
 *
 * @param  {Object} options The options for the selector
 * @param  {string} options.model The name of the model to get the items from
 * @return {Function} The newly created reselect selector
 * @public
 * @author Connor Taylor
 *
 * @example
 * const state = {
 *   article: {
 *     allIds: [1, 2],
 *     byId: {
 *       1: { id: 1, url: `http://www.google.com/foo`, publishDate: `2018-01-15`, featured: false },
 *       2: { id: 2, url: `http://www.google.com/bar`, publishDate: `2018-01-16` featured: true },
 *     }
 *   }
 * }
 *
 * const all = makeAllSelector({ model: `article` });
 * all(state);
 * // returns
 * [
 *   { id: 1, url: `http://www.google.com/foo`, publishDate: `2018-01-15`, featured: false },
 *   { id: 2, url: `http://www.google.com/bar`, publishDate: `2018-01-16` featured: true }
 * ]
 */

var makeAllSelector = function makeAllSelector(_ref) {
  var model = _ref.model;
  return createSelector([function (state) {
    return state[model].allIds;
  }, function (state) {
    return state[model].byId;
  }], function (allIds, byId) {
    if (!allIds) {
      throw new Error("The all selector requires a state." + model + ".allIds reducer!");
    }

    if (!byId) {
      throw new Error("The all selector requires a state." + model + ".byId reducer!");
    }

    return allIds.map(function (id) {
      return byId[id];
    });
  });
};
/** @component */


export default makeAllSelector;